import * as CONST from '../ActionTypes';

const initState = {
  columnList: [],
  detailColumn: null,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  isUpdateSuccess: false,
  isUpdateFailure: false,
};

const columnReducer = (state = initState, action) => {
  switch (action.type) {
    // -----------------
    // FAQ情報一覧取得
    // -----------------
    case CONST.GET_COLUMN_LIST_SUCCESS:
      return {
        ...state,
        columnList: action.payload.column_list,
        page_number: action.payload.page_number,
        isSuccess: true,
        isFailure: false,
      };
    case CONST.GET_COLUMN_LIST_FAILURE:
      return {
        ...state,
        columnList: [],
        isFailure: true,
        isSuccess: false,
        errorMessage: action.payload,
      };
    case CONST.GET_COLUMN_DETAIL_SUCCESS:
      return {
        ...state,
        detailColumn: action.payload,
      };
    case CONST.GET_COLUMN_DETAIL_FAILURE:
      return {
        ...state,
        detailColumn: {},
      };
    case CONST.UPDATE_COLUMN_SUCCESS:
      return {
        ...state,
        isUpdateSuccess: true,
        isUpdateFailure: false,
      };
    case CONST.UPDATE_COLUMN_FAILURE:
      return {
        ...state,
        isUpdateSuccess: false,
        isUpdateFailure: true,
      };
    default:
      return state;
  }
};

export default columnReducer;
